import { PATHS, URL_PARAMS } from '../constants';

interface GetDetectionsTablePathForProductionCoInput {
    /**
     * An end date for the date range.
     */
    dateEnd: Date | null;
    /**
     * A human-friendly name for the date. This should conform to one of the options used in
     * packages/components/src/DateRangeSelectorDropdown/DateRangeSelectorDropdown.tsx so that it
     * matches up with the list of available options used for further date range selection.
     */
    dateLabel: string;
    /**
     * A start date for the date range.
     */
    dateStart: Date | null;
    /**
     * The name of the production company
     */
    programProductionCompany?: Maybe<string>;
    /**
     * The search params portion of the URL, like '?foo=bar&fizz=buzz'
     */
    search: string;
}

/**
 * Get the href path for the Detections table which includes URL parameters that specify the
 * production company name and date range.
 * @param input - see {@link GetDetectionsTablePathForProductionCoInput}
 */
export const getDetectionsTablePathForProductionCo = ({
    dateEnd,
    dateLabel,
    dateStart,
    programProductionCompany,
    search,
}: GetDetectionsTablePathForProductionCoInput): string | null => {
    if (!programProductionCompany) {
        return null;
    }

    const searchParams = new URLSearchParams(search);

    searchParams.set(
        URL_PARAMS.PROGRAM_PRODUCTION_COMPANY,
        encodeURIComponent(programProductionCompany),
    );
    searchParams.set(URL_PARAMS.DATE_LABEL, encodeURIComponent(dateLabel));

    if (dateEnd !== null) {
        searchParams.set(
            URL_PARAMS.DATE_END,
            encodeURIComponent(dateEnd.toISOString()),
        );
    }

    if (dateStart !== null) {
        searchParams.set(
            URL_PARAMS.DATE_START,
            encodeURIComponent(dateStart.toISOString()),
        );
    }

    return `${PATHS.DETECTIONS}?${searchParams.toString()}`;
};
